import React from "react";
import { Router } from "@reach/router";
import { Route } from "components";

import { HeaderLanding } from "./HeaderLanding";
import { HeaderWithButton } from "./HeaderWithButton";
import { FooterLanding } from "./FooterLanding";

export const Banners: React.FC = () => (
  <Router>{Route("/", HeaderLanding)}</Router>
);

export const SummaryHeader: React.FC = () => (
  <Router>{Route("/summary", HeaderWithButton)}</Router>
);

export const CheckoutHeader: React.FC = () => (
  <Router>{Route("/checkout", HeaderWithButton)}</Router>
);

export const Footer: React.FC = () => (
  <Router>{Route("/", FooterLanding)}</Router>
);